import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=cb584ed8&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=js"
export * from "./Audience.vue?vue&type=script&lang=js"
import style0 from "./Audience.vue?vue&type=style&index=0&id=cb584ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb584ed8",
  null
  
)

export default component.exports